import { render, staticRenderFns } from "./nnaj.vue?vue&type=template&id=3ed45470&"
import script from "./nnaj.vue?vue&type=script&lang=js&"
export * from "./nnaj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports